import { render, staticRenderFns } from "./InfoEmailTemplate.vue?vue&type=template&id=ce72639c&scoped=true&"
import script from "./InfoEmailTemplate.vue?vue&type=script&lang=js&"
export * from "./InfoEmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InfoEmailTemplate.vue?vue&type=style&index=0&id=ce72639c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce72639c",
  null
  
)

export default component.exports